import { Box, Divider, Flex, Popover, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconLogout } from "@tabler/icons-react";
import { OpenChatButton } from "components/Chat";
import HeaderLogo from "components/HeaderLogo";
import NotificationWidget from "components/NotificationWidget";
import UserAvatar from "components/UserAvatar";
import useLogout from "hooks/useLogout";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { useAuthStore } from "stores/authStore";
import { HEADER_HEIGHT } from "../../common/constants";

interface DesktopHeaderProps {}

const DesktopHeader: FC<DesktopHeaderProps> = ({}) => {
  const { t } = useTranslation("common");
  const { logout, isPending } = useLogout();

  const avatar = useAuthStore(state => state.avatar);
  const email = useAuthStore(state => state.email);
  const fullName = useAuthStore(state => state.fullName);

  const [, { close }] = useDisclosure(false);

  return (
    <Box
      px={"sm"}
      className="bg-white flex items-center shadow-sm sticky top-0 z-30 w-full"
      component={"header"}
      h={HEADER_HEIGHT}
    >
      <Flex w={"100%"} justify={"space-between"} align={"center"}>
        <Link to="/home" onClick={close}>
          <HeaderLogo />
        </Link>
        <Flex gap={"sm"}>
          <OpenChatButton />
          <NotificationWidget />
          <Popover
            radius={"15px"}
            keepMounted
            classNames={{ dropdown: "!p-0 min-w-[312px] !border-gray" }}
            position="bottom-end"
          >
            <Popover.Target>
              <button className="cursor-pointer">
                <UserAvatar userName={fullName} avatarId={avatar} />
              </button>
            </Popover.Target>
            <Popover.Dropdown>
              <Flex align={"center"} fz={"sm"} gap={"sm"} p={10}>
                <Flex
                  justify={"center"}
                  align={"center"}
                  className="text-white w-12 h-12 rounded-full"
                >
                  <UserAvatar userName={fullName} avatarId={avatar} />
                </Flex>
                <Box maw={300}>
                  {fullName && (
                    <Text fw={700} lineClamp={1} lh={1} c={"gray.8"}>
                      {fullName}
                    </Text>
                  )}
                  {email && (
                    <Text c={"gray.8"} lineClamp={1} lh={"sm"} fz={"sm"}>
                      {email}
                    </Text>
                  )}
                </Box>
              </Flex>
              <Divider color={"gray.1"} />

              <button
                data-testid="logout-button"
                disabled={isPending}
                onClick={logout}
                className="flex items-center p-2 gap-1 text-gray-light text-xs cursor-pointer"
              >
                <IconLogout className="text-gray-dark" />
                <span className="text-gray-dark font-bold">{t("logout")}</span>
              </button>
            </Popover.Dropdown>
          </Popover>
        </Flex>
      </Flex>
    </Box>
  );
};

export default DesktopHeader;
